import { render, staticRenderFns } from "./EditBotCardsModal_.vue?vue&type=template&id=571aca24&scoped=true&"
import script from "./EditBotCardsModal_.vue?vue&type=script&lang=js&"
export * from "./EditBotCardsModal_.vue?vue&type=script&lang=js&"
import style0 from "./EditBotCardsModal_.vue?vue&type=style&index=0&id=571aca24&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "571aca24",
  null
  
)

export default component.exports